/*
 * @Author: along longwang6@163.com
 * @Date: 2025-05-27 17:37:19
 * @LastEditors: along longwang6@163.com
 * @LastEditTime: 2025-06-27 15:00:53
 * @FilePath: /ehr-web/src/components/AuthRoute/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * 登录鉴权
 */
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import {
  checkHunterLogin,
  // redirectToLoginHunter,
  redirectToLogin,
} from '@/utils/auth';
import { useEffect, useState } from 'react';
import { useStore } from '@/store';
import { Spin } from '@arco-design/web-react';

interface AuthRouteProps {
  children: React.ReactNode;
}

const AuthRoute: React.FC<AuthRouteProps> = ({ children }) => {
  const location = useLocation();

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const user = useStore('user');
  // console.log('🚀 ~ user:', user.fetchPermissionList());

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const isLoggedIn = await checkHunterLogin();
        setIsAuthenticated(isLoggedIn);
        if (!isLoggedIn) {
          // 保存当前路径，登录后跳回
          redirectToLogin(true);
        }
        // 等待用户信息加载完成
        await user.fetchPermissionList();
      } catch (error) {
        console.error('Auth check failed:', error);
        redirectToLogin(true);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, [location.pathname, user]);

  if (isLoading) {
    // 可以返回一个加载中的状态
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Spin />
      </div>
    );
  }

  if (!isAuthenticated) {
    return null; // 已经调用 redirectToLogin，这里返回 null
  }

  return <>{children}</>;
};

export default observer(AuthRoute);
